<template>
  <div class="listParts_wrapper message_list_Wrapper">
    <div class="title_area wrapper">
      <h4 class="inner light">
        <span>メッセージ</span>
      </h4>
    </div>
    <div class="message_list_Inner">
      <ul class="message_list">
        <li
          class="list unread selected"
          v-for="(latestMessages, fromParticipantId) in $store.getters['directMessages/getLatestMessages']"
          :key="fromParticipantId"
        >
          <a
            @click="
              multipleMethod(fromParticipantId)
              updateMessageToRead()
            "
            class="txtLink_w"
          >
            <div class="messageList_leftParts">
              <h5 class="flex_center">
                <div class="pIcon_wrapper">
                  <span class="blinking" v-if="!latestMessages.isRead">●</span>
                  <img :class="{isAdmin: latestMessages.participant.isAdmin()}" :src="latestMessages.participant.avatar" />
                </div>
                <p>
                  <span>{{ latestMessages.participant.organization }}</span>
                  {{ latestMessages.participant.name }}
                </p>
                <span class="receive_wrapper">{{ getDiffFromNow(latestMessages.createdAt) }}</span>
              </h5>
              <div class="message_txt">
                <p v-if="latestMessages.type === 1">
                  <RawHtml :text="latestMessages.message | truncate" />
                </p>
                <p v-else>
                  <span>トークルームのお誘いがありました</span>
                </p>
              </div>
            </div>
            <div class="arrowRight_wrapper"><i class="fas fa-angle-right" /></div>
          </a>
        </li>
      </ul>
    </div>

    <transition name="fade">
      <Modal v-show="showModal" @close="invertModalStatus">
        <div slot="content">
          <div class="content-header inner">
            <h2>
              <span>{{ targetUser.name }}</span>
            </h2>
            <button @click="invertModalStatus" class="close-btn">
              <fa-icon icon="times" />
            </button>
          </div>
          <div class="chats">
            <Message
              v-for="(directMessage, index) in messages"
              :key="index"
              :direct-message="directMessage"
              :target-user="targetUser"
              @invert-modal-status="invertModalStatus"
            />
          </div>

          <div class="submitChat">
            <MessageForm @dispatch-dm="dispatchDm" />
<!-- https://valeur.backlog.jp/view/YOSHIDA_HP_MANAGE-4113 トークルーム機能を非表示中 -->
<!--            <div class="submit-invitation">-->
<!--              <SubmitInvitationButton @dispatch-invite-dm="inviteDm" />-->
<!--              <div class="about-talkRoom inner" @mouseover="mouseOverAction" @mouseleave="mouseLeaveAction">-->
<!--                <transition name="fade">-->
<!--                  <div class="mouseOver-content inner" v-if="hoverFlag">-->
<!--                    <span>招待を送った相手と１対１でビデオ通話をすることができます。</span>-->
<!--                  </div>-->
<!--                </transition>-->
<!--                <fa-icon icon="question-circle" />-->
<!--                <span>トークルームとは</span>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import Modal from "../elements/Modal"
import Message from "../elements/Message"
import MessageForm from "../elements/MessageForm"
import SubmitInvitationButton from "../elements/SubmitInvitationButton"
import {DirectMessage} from "socket_if"
import RawHtml from "../elements/RawHtml"

export default {
  name: "DirectMessageWindow",
  components: {
    Modal,
    Message,
    MessageForm,
    SubmitInvitationButton,
    RawHtml
  },
  data() {
    return {
      showModal: false,
      hoverFlag: false,
      targetUser: {}
    }
  },
  computed: {
    messages() {
      const messages = this.$store.getters["directMessages/getByUserId"](this.targetUser.id)
      this.scrollToEnd()
      return messages
    }
  },
  methods: {
    multipleMethod(targetUserId) {
      this.setTargetUser(targetUserId)
      this.invertModalStatus()
    },
    setTargetUser(targetUserId) {
      this.targetUser = this.$store.getters["participants/getByUserId"](targetUserId)
    },
    invertModalStatus() {
      this.showModal = !this.showModal
    },
    mouseOverAction() {
      this.hoverFlag = true
    },
    mouseLeaveAction() {
      this.hoverFlag = false
    },
    dispatchDm(message) {
      this.$socket.dispatcher.sendDirectMessage(
        new DirectMessage({
          message: message,
          type: 1, // type: "1: message, 2: invaite"
          fromParticipantId: this.$store.getters["auth/id"],
          toParticipantId: this.targetUser.id,
          isRead: false,
          createdAt: this.$moment.now().toString()
        })
      )
    },
    inviteDm() {
      this.$socket.dispatcher.inviteDirectMessage(
        new DirectMessage({
          message: null,
          type: 2,
          fromParticipantId: this.$store.getters["auth/id"],
          toParticipantId: this.targetUser.id,
          isRead: false,
          createdAt: this.$moment.now().toString()
        })
      )
    },
    getDiffFromNow(createdAt) {
      return this.$moment.unix(createdAt / 1000).fromNow()
    },
    updateMessageToRead() {
      _(this.messages)
        .filter(message => {
          return !message.isRead
        })
        .forEach(message => {
          message.isRead = true
          this.$socket.dispatcher.updateDirectMessageToRead(new DirectMessage(message))
        })
    },
    scrollToEnd() {
      this.$nextTick(() => {
        const container = this.$el.querySelector(".modal-mask .chats")
        container.scrollTop = container.scrollHeight
      })
    }
  },
  filters: {
    truncate: function(value) {
      const length = 20
      const omission = "..."
      if (value.length <= length) return value

      return value.substring(0, length) + omission
    }
  }
}
</script>
